import * as React from "react";
import { Row, Col, Button, Spin, Icon, Alert, Tooltip } from "antd";
import { ForwardInput } from "../../../shared/ForwardInput";
import styled from "styled-components";
import { AddressCreationState } from "../../../lib/model/AddressState";
import { ApiClient } from "../../../lib/api";
import { AddressValidator } from "../../../lib/validators/AddressValidator";

const client = new ApiClient();
const validator = new AddressValidator();

type Props = {
  address: AddressCreationState;
  onChange: (value: AddressCreationState) => void;
  onSaveClick: () => void;
};

const HintLabel = styled.span`
  font-size: 11px;
  font-weight: 300;
  line-height: 1.27;
  color: rgba(6, 26, 50, 0.56);
`;

export class AddressCreationForm extends React.Component<Props, {}> {
  render() {
    const { onChange, address } = this.props;
    const {
      zipCode,
      companyName,
      street,
      houseNumber,
      contactName,
      contactPhone,
      extraInfo,
      isZipValidationLoading,
      validatedZip
    } = address;
    return (
      <>
        <Row type="flex" align="bottom" gutter={16}>
          <Col span={12}>
            <ForwardInput
              label="* Firmenname"
              value={companyName}
              hasError={!validator.validateCreation(address).companyName}
              onChange={e =>
                onChange({ ...address, companyName: e.target.value })
              }
            />
          </Col>
          <Col span={12}>
            {isZipValidationLoading && (
              <Spin indicator={<Icon type="loading" spin />} spinning={true} />
            )}
            {!isZipValidationLoading && validatedZip && (
              <Alert
                message={validatedZip.userMessage()}
                type={validatedZip.alertType()}
                showIcon
              />
            )}
          </Col>
        </Row>
        <Row type="flex" gutter={16}>
          <Col span={12}>
            <ForwardInput
              label="* Straße"
              value={street}
              hasError={!validator.validateCreation(address).street}
              onChange={e => onChange({ ...address, street: e.target.value })}
            />
          </Col>
          <Col span={6}>
            <ForwardInput
              label="* Hausnummer"
              value={houseNumber}
              hasError={!validator.validateCreation(address).houseNumber}
              onChange={e =>
                onChange({ ...address, houseNumber: e.target.value })
              }
            />
          </Col>
          <Col span={6}>
            <ForwardInput
              label="* Postleitzahl"
              value={zipCode}
              hasError={!validator.validateCreation(address).zip}
              onChange={this.handleZipChanged}
            />
          </Col>
        </Row>
        <Row type="flex" gutter={16}>
          <Col span={12}>
            <ForwardInput
              label={
                <>
                  <span>Kontaktperson </span>
                  <Tooltip
                    title={
                      "Diese Information wird dauerhaft im Adressbuch gespeichert."
                    }
                  >
                    <Icon type="info-circle" style={{ color: "#386EE8" }} />
                  </Tooltip>
                </>
              }
              value={contactName}
              onChange={e =>
                onChange({ ...address, contactName: e.target.value })
              }
            />
          </Col>
          <Col span={12}>
            <ForwardInput
              label="Telefon"
              value={contactPhone}
              onChange={e =>
                onChange({ ...address, contactPhone: e.target.value })
              }
            />
          </Col>
        </Row>
        <Row type="flex">
          <Col span={24}>
            <ForwardInput
              label={
                <>
                  <span>Generelle Besonderheiten an dieser Ladestelle </span>
                  <Tooltip
                    title={
                      "Diese Information wird dauerhaft im Adressbuch gespeichert. Geben Sie hier beispielsweise generelle Pausenzeiten, nicht aber Referenznummern o. Ä. an."
                    }
                  >
                    <Icon type="info-circle" style={{ color: "#386EE8" }} />
                  </Tooltip>
                </>
              }
              value={extraInfo}
              onChange={e =>
                onChange({ ...address, extraInfo: e.target.value })
              }
            />
          </Col>
        </Row>
        <Row type="flex" style={{ marginTop: 24 }} gutter={12}>
          <Col span="auto">
            <Button
              type="primary"
              style={{ borderRadius: 0 }}
              disabled={!validator.validateCreation(address).overall}
              onClick={this.props.onSaveClick}
            >
              ok
            </Button>
          </Col>
          <Col span="auto">
            <HintLabel>* Pflichtfelder</HintLabel>
          </Col>
        </Row>
      </>
    );
  }
  handleZipChanged = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { onChange, address } = this.props;
    const newValue = e.target.value;
    if (newValue.length === 5) {
      onChange({ ...address, isZipValidationLoading: true, zipCode: newValue });
      const res = await client.checkZip(newValue);
      onChange({
        ...address,
        isZipValidationLoading: false,
        validatedZip: res,
        zipCode: newValue
      });
    } else {
      onChange({
        ...address,
        isZipValidationLoading: false,
        validatedZip: undefined,
        zipCode: newValue
      });
    }
  };
}
